import { HttpResponse } from 'shell/models/http-response';
import { MunicipalityEndedForm } from '../components/municipality/ended';
import { Municipality } from 'shell/models/municipality';
import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';

export const transformResponseMunicipalityEnded = (
  response: AxiosResponse<HttpResponse<Municipality>>
): MunicipalityEndedForm => {
  const municipalityPayload = response?.data?.payload;

  const [comuneCessato] = municipalityPayload.comuneCessato || [];

  return {
    code: municipalityPayload.key?.codice,
    name: municipalityPayload.nome,
    fiscalCode: municipalityPayload.codFiscale || '',
    istatCode: municipalityPayload.codIstat,
    province: municipalityPayload.provincia?.trim(),
    foreignState: municipalityPayload.provincia?.trim(),
    capital: municipalityPayload.capoluogo?.trim() === 'S' ? true : false,
    isForeign: municipalityPayload.statoEsteroVO ? true : false,
    institutionDate: municipalityPayload.dataIstituz
      ? DateTime.fromISO(municipalityPayload.dataIstituz)
      : null,
    endDate: comuneCessato?.dataCessazione ? DateTime.fromISO(comuneCessato?.dataCessazione) : null,
    oldCode: comuneCessato?.nuovoCodice?.toString(),
    court: municipalityPayload.tribunale?.toString(),
    cap: municipalityPayload.cap?.toString(),
    site: municipalityPayload.comuneTerritorioConsolato?.codiceConsolato || '',
    territory: municipalityPayload.codTerritorio?.toString() || '',
    region: municipalityPayload.regione?.trim(),
  };
};

export const transformRequestMunicipalityEnded = (
  formValues: MunicipalityEndedForm | undefined
): Municipality => {
  return {
    comuneTerritorioConsolato:
      formValues?.territory || formValues?.site
        ? {
            codiceTerritorio: formValues?.territory || undefined,
            codiceConsolato: formValues?.site || undefined,
          }
        : undefined,
    dataIstituz: formValues?.institutionDate?.toFormat('yyyyMMdd') || undefined,
    comuneCessato:
      formValues?.endDate || formValues?.oldCode
        ? [
            {
              dataCessazione: formValues?.endDate?.toFormat('yyyyMMdd') || undefined,
              nuovoCodice: formValues?.oldCode
                ? Number.parseInt(formValues?.oldCode, 10)
                : undefined,
            },
          ]
        : undefined,
    tribunale: formValues?.court ? Number.parseInt(formValues.court, 10) : undefined,
    cap: formValues?.cap || undefined,
    codIstat: formValues?.istatCode || undefined,
    regione: formValues?.region || undefined,
    provincia: formValues?.province || formValues?.foreignState || undefined,
    codFiscale: formValues?.fiscalCode || undefined,
    capoluogo: formValues?.capital ? 'S' : 'N',
    nome: formValues?.name || undefined,
    key: formValues?.code
      ? {
          codice: formValues?.code,
        }
      : undefined,
  };
};
